import { PropsWithChildren, FC } from "react";
import s from "./styles.module.scss";

interface Props extends PropsWithChildren {
  [key: string]: unknown;
}

const VirtuosoCustomItem: FC<Props> = ({ children, ...props }) => (
  <div {...props} className={s.item}>
    {children}
  </div>
);

export default VirtuosoCustomItem;
